module.exports = __webpack_public_path__ + "static/media/step_4.23e443cc.png";